export const ParseToken = (token) => {
  return decodeURIComponent(token).replace(/%20/g, " ");
};

export const ConvertDateToEpoch = (dateString) => {
  const date = new Date(dateString);
  const epochSeconds = Math.floor(date.getTime() / 1000);
  return epochSeconds;
};
